<script lang="ts">
  import {onMount, SvelteComponent} from 'svelte';

  let component: SvelteComponent;

  onMount(async () => {
    const module = await import('../../assets/img/svg/sprite/build/icons.symbol.svg.svelte');

    component = module.default as unknown as SvelteComponent;
  });
</script>

<div style="position: absolute; z-index: -1;">
  <svelte:component this={component} />
</div>
